module.exports = __webpack_public_path__ + "static/media/preparing-before-intervention.74409e22.md";